import styled from 'styled-components';

export const VideoTrailer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  z-index: 999;

  .aspect-wrap {
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 56.25%; /* 16.9 ratio */
  }

  .trailer {
    position: absolute;
    top: 0;
    left: 0;
    width: 70%;
    height: 70%;
    transform: translateX(20%) translateY(15%);
    z-index: 4;
  }
`;
